var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.$style.style }, [
    _c("div", { staticClass: "img-view" }, [
      _c(
        "p",
        {
          staticClass: "pic-box",
          on: {
            click: function($event) {
              _vm.showPicPopup(_vm.imgSrc)
            }
          }
        },
        [_c("img", { attrs: { src: _vm.imgSrc, alt: "" } })]
      )
    ]),
    _vm._v(" "),
    _vm.showPopup
      ? _c("div", { staticClass: "pic-popup" }, [
          _c(
            "a",
            {
              staticClass: "close-btn",
              attrs: { href: "javascript:;" },
              on: {
                click: function($event) {
                  _vm.showPicPopup("none")
                }
              }
            },
            [_vm._v("×")]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "img-view" }, [
            _c("img", { attrs: { src: _vm.imgSrc, alt: "" } })
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }